import React from "react";
import './SingleCard.css';
import { Box, Image } from "@chakra-ui/react";

function SingleCard({ card, handleChoice, flipped, disabled }) {

    const handleClick = () => {
        if (!disabled) {
            handleChoice(card);
        }
    }

    return (
        <Box className="card">
            <Box className={flipped ? "flipped" : ""}>
                <Image className="card-front" src={card.src} alt="card front"/>
                <Image 
                    className="card-back" 
                    src="/img/cover.png" 
                    onClick={handleClick} 
                    alt="card cover" 
                />
            </Box>
        </Box>
    );
}

export default SingleCard;